import { PhTextAlignLeft } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import {
  type CampaignResource,
  type TextSection,
  type TextSectionCreate,
  type TextSectionUpdate,
} from '../../types'
import { emailBlockMethods } from '../common/methods'

import TextEditor from './editor/TextEditor.vue'
import { createTextSection } from './methods/createTextData'
import TextPreview from './preview/TextPreview.vue'
const i18n = i18nPlugin.global

export const TextBlockModule: BuilderBlockModule<
  TextSection,
  TextSectionCreate,
  TextSectionUpdate,
  CampaignResource
> = {
  createData: createTextSection,
  editor: TextEditor,
  meta: [
    {
      icon: PhTextAlignLeft,
      key: 'heading',
      label: i18n.t('email-builder.blocks.heading'),
    },
    {
      icon: PhTextAlignLeft,
      key: 'subheading',
      label: i18n.t('email-builder.blocks.subheading'),
    },
    {
      icon: PhTextAlignLeft,
      key: 'paragraph',
      label: i18n.t('email-builder.blocks.paragraph'),
    },
  ],
  methods: emailBlockMethods,
  preview: TextPreview,
}
